var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 73,
    viewBox: "0 0 77 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 75,
    height: 71,
    stroke: "#58CDFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4993 46.281C45.5205 46.281 51.6602 49.3006 55 53.8051L51.4687 55.4754C48.7508 52.2541 43.958 50.1152 38.4993 50.1152C33.0405 50.1152 28.2478 52.2541 25.5299 55.4754L22 53.8033C25.34 49.2999 31.479 46.281 38.4993 46.281ZM38.4993 17.5244C43.7932 17.5244 48.0848 21.816 48.0848 27.1099V32.8613C48.0848 38.016 44.0161 42.2202 38.9151 42.438L38.4993 42.4468C33.2053 42.4468 28.9138 38.1552 28.9138 32.8613V27.1099C28.9138 21.9553 32.9824 17.751 38.0835 17.5333L38.4993 17.5244ZM38.4993 21.3586C35.4363 21.3586 32.9326 23.7529 32.7577 26.772L32.748 27.1099V32.8613C32.748 36.0377 35.3228 38.6126 38.4993 38.6126C41.5622 38.6126 44.066 36.2183 44.2408 33.1992L44.2506 32.8613V27.1099C44.2506 23.9336 41.6755 21.3586 38.4993 21.3586Z",
    fill: "#58CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserr);
export default __webpack_public_path__ + "static/media/userr.9906178fea9a247be826de8426ea5cbd.svg";
export { ForwardRef as ReactComponent };